export default __webpack_public_path__ + "dfd358a9f24ebcb4eee4c4c99dc79786.png";